import { ActionType } from '../constants/ActionTypes';
import config from '../constants/Configs';
import { Constants } from '../constants/Constants';
import { RestPath } from '../constants/SitePaths';
import Utils from '../services/Utils';
import axios from 'axios';
import NotificationService from '../components/base/notifications/NotificationService';
import { ErrorHelper } from '../services/helpers/error/ErrorHelper';
const moment = require('moment');

export const getClientMessagesBegin = () => ({
    type: ActionType.GET_CLIENT_MESSAGES_BEGIN
});
export const getClientMessagesAndKeepOldBegin = () => ({
    type: ActionType.GET_CLIENT_MESSAGES_AND_KEEP_OLD_BEGIN
});

export const getClientMessagesError = (data) => ({
    type: ActionType.GET_CLIENT_MESSAGES_ERROR,
    payload: data
});
export const getClientMessagesSuccess = (data) => ({
    type: ActionType.GET_CLIENT_MESSAGES_SUCCESS,
    payload: data
});
export const getClientMessagesAndKeepOldSuccess = (data) => ({
    type: ActionType.GET_CLIENT_MESSAGES_AND_KEEP_OLD_SUCCESS,
    payload: data
});

export const readClientMessageBegin = (data) => ({
    type: ActionType.GET_CLIENT_UNREAD_MESSAGES_COUNT_BEGIN,
    payload: data
});
export const readClientMessageError = (data) => ({
    type: ActionType.GET_CLIENT_UNREAD_MESSAGES_COUNT_ERROR,
    payload: data
});
export const readClientMessageSuccess = (data) => ({
    type: ActionType.READ_CLIENT_MESSAGE_SUCCESS,
    payload: data
});

export const getClientUnreadMessagesCountBegin = () => ({
    type: ActionType.READ_CLIENT_MESSAGE_BEGIN
});
export const getClientUnreadMessagesCountError = (data) => ({
    type: ActionType.READ_CLIENT_MESSAGE_ERROR,
    payload: data
});
export const getClientUnreadMessagesCountSuccess = (data) => ({
    type: ActionType.GET_CLIENT_UNREAD_MESSAGES_COUNT_SUCCESS,
    payload: data
});

export const saveMessageBegin = () => ({
    type: ActionType.SAVE_MESSAGE_BEGIN
});

export const deleteMessageBegin = (id, allMessages) => ({
    type: ActionType.DELETE_MESSAGE_BEGIN,
    payload: { id, allMessages }
});
export const deleteMessageSuccess = (id, allMessages) => ({
    type: ActionType.DELETE_MESSAGE_SUCCESS,
    payload: { id, allMessages }
});
export const deleteMessageError = (id, allMessages) => ({
    type: ActionType.DELETE_MESSAGE_ERROR,
    payload: { id, allMessages }
});

export const saveMessageError = (data) => ({
    type: ActionType.SAVE_MESSAGE_ERROR,
    payload: data
});

export const saveMessageSuccess = (data) => {
    const now = moment().format('YYYY-MM-DDTHH:mm:ss');
    data.creationTime = now;
    data.lastUpdateTime = now;
    data.nestedMessages = [];
    data.canAnswer = true;
    data.state = 1;

    return {
        type: ActionType.SAVE_MESSAGE_SUCCESS,
        payload: data
    }
}


export function getClientMessages(data, types, clearOld) {
    return dispatch => {
        clearOld ? dispatch(getClientMessagesBegin()) : dispatch(getClientMessagesAndKeepOldBegin());
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_CLIENT_MESSAGES + Utils.objectToQueryParams(data) + '&' + types
        }).then((response) => {
            clearOld ? dispatch(getClientMessagesSuccess(response.data)) : dispatch(getClientMessagesAndKeepOldSuccess(response.data));
            return response.data && response.data.messages;
        }).catch((error) => {
            if (error.response) {
                dispatch(getClientMessagesError(error.response.data));
            } else {
                dispatch(getClientMessagesError(error));
            }
            return;
        });
    };
}

export function getMessageChain(id) {
    return dispatch => {
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.GET_MESSAGE_CHAIN}?id=${id}`
        }).then((response) => {
            //dispatch(getClientMessagesSuccess(response.data));
            return response.data;
        }).catch((error) => {
            //dispatch(getClientMessagesError(error.response.data));
            return;
        });
    };
}

export function getClientUnreadMessagesCount() {
    return dispatch => {
        dispatch(getClientUnreadMessagesCountBegin());
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_CLIENT_UNREAD_MESSAGES_COUNT
        }).then((response) => {
            dispatch(getClientUnreadMessagesCountSuccess(response.data));
        }).catch((error) => {
            if (error.response) {
                dispatch(getClientUnreadMessagesCountError(error.response.data));
            } else {
                dispatch(getClientUnreadMessagesCountError(error));
            }
        });
    };
}

export const markAllItemsRead = (id, allMessages) => ({
    type: ActionType.MARK_IDS_READ,
    payload: { id, allMessages }
});

export const readMessage = (id) => ({
    type: ActionType.READ_MESSAGE,
    payload: id
});

export function readClientMessage(id, allMessages) {
    return dispatch => {
        dispatch(readClientMessageBegin(id));
        return axios({
            method: Constants.POST,
            url: config.BASE_URL + RestPath.READ_CLIENT_MESSAGE,
            params: { messageId: id, allMessages }
        }).then((response) => {
            dispatch(readClientMessageSuccess({ id, allMessages }));
            dispatch(getClientUnreadMessagesCount());
        }).catch((error) => {
            dispatch(readClientMessageError(id));
        });

    };
}

export function saveMessage(data) {
    const boundary = String(Math.random()).slice(2);
    const boundaryMiddle = '--' + boundary + '\r\n';
    const boundaryLast = '--' + boundary + '--\r\n';

    let body = ['\r\n'];
    for (var key in data) {
        body.push('Content-Disposition: form-data; name="' + key + '"\r\n\r\n' + data[key] + '\r\n');
    }

    return dispatch => {
        dispatch(saveMessageBegin());
        return axios({
            method: Constants.POST,
            url: config.BASE_URL + RestPath.SAVE_MESSAGE,
            headers: {
                'Content-Type': 'multipart/form-data; boundary=' + boundary
            },
            data: body.join(boundaryMiddle) + boundaryLast
        }).then((response) => {
            dispatch(saveMessageSuccess(response.data));
            return response.data;
        }).catch((error) => {
            NotificationService.error({message : ErrorHelper.getMessage(error)});
            if (error.response) {
                dispatch(saveMessageError(error.response.data));
            } else {
                dispatch(saveMessageError(error));
            }
        });
    }
}

export function deleteMessage(id, isAll) {
    return dispatch => {
        dispatch(deleteMessageBegin(id, isAll));
        return axios({
            method: Constants.DELETE,
            url: config.BASE_URL + RestPath.DELETE_MESSAGE,
            params: { ids: [...id], isAll }
        }).then((response) => {
            dispatch(deleteMessageSuccess(id, isAll));

        }).catch((error) => {
            dispatch(deleteMessageError(id, isAll));
        });
    }
}